import React,{useContext} from "react";
import InfoIcon from "../../../../../components/SVGComponents/InfoIcon";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import "./styles.css"
import ClearIcon from "../../../../../components/SVGComponents/ClearIcon";
import { t } from "i18next";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";


const MarkWarning = (props) => {

  const {  checkBoundingBoxExistPathalogy } =
  useContext(ViewportContext);

  return (
    <>
    { props.success ?   
     <div className="marking-container" style={{background:props.backgroundColor}}>
     <div  className="info-icon">
     <InfoIcon />
     </div>
       
       <div className="marking-text">

         {!props.success?`Kindly mark the area for ${props.pathalogyName}`:props.pathalogyName}
       </div>
      
       <div className="clear-icon" onClick={props.handleRemoveWarning}>
         
       <ClearIcon />
       </div>
      
   </div>
    :
    
    <div className="marking-container-info-icon" style={{display:'flex',flexDirection:'row', background:props.backgroundColor}}>
      <div className="marking-info-container" >
      <div  className="info-icon">
        <InfoIcon />
        </div>
      </div>
    
      <div className="marking-msg-container" style={{background:props.backgroundColor}}>
        
          
          <div className="marking-text">

            {!props.success?`Kindly mark the area for ${props.pathalogyName}`:props.pathalogyName}
          </div>
          {props.success && <div className="done-marking-container" onClick={props.handleRemoveWarning}>
            <span className="done-marking-text">{t("button.done")}</span>
          </div>}
          {props.id != null && checkBoundingBoxExistPathalogy(props.id) && <div className="clear-icon" onClick={props.handleRemoveWarning}>
            
          <ClearIcon />
          </div>}
         
      </div>
      </div>}
    </>
  );
};

export default MarkWarning;
